export default function ($rootScope, $scope, $http, $q, $timeout, $stateParams, $state, $uibModalInstance, CONFIG, UtilitiesFactory, FirebaseFactory, ngToast) {
    'ngInject';
    let utilities = UtilitiesFactory.getUtilities();
    let T = $scope.$root.T;

    $scope.user = {
        isAdmin: false
    };
    $scope.error = '';
    $scope.regions = $rootScope.regions;
    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;

    /***
     * Submit Form
     */
    $scope.submit = () => {
        $scope.error = '';
        let host = window.location.host.split('.')[0];
        /***
         * Workaround: https://stackoverflow.com/questions/37517208/firebase-kicks-out-current-user/38013551#38013551
         *
         */

        //TODO ADD to configuration file
        let config = {
            apiKey: "AIzaSyBYhlqdcQpIqLargbODZmqnisgLQrmpXVc",
            authDomain: "wfv-cms.firebaseapp.com",
            databaseURL: "https://wfv-cms.firebaseio.com",
            projectId: "wfv-cms",
            storageBucket: "wfv-cms.appspot.com",
            messagingSenderId: "141416234892"
        };

        if (host.indexOf('localhost') >= 0 || host === 'wfv-cms-develop') {
            config = {
                apiKey: "AIzaSyCx_6aQm5xhXHiAhFdrmaefw4mFpQlLS60",
                authDomain: "wfv-cms-develop.firebaseapp.com",
                databaseURL: "https://wfv-cms-develop.firebaseio.com",
                projectId: "wfv-cms-develop",
                storageBucket: "wfv-cms-develop.appspot.com",
                messagingSenderId: "6981202812"
            };
        }

        let secondaryApp = firebase.initializeApp(config, "Secondary");

        secondaryApp.auth().createUserWithEmailAndPassword($scope.user.email, $scope.user.password).then( (response) => {
            let user = {
                displayName: $scope.user.displayName,
                uid: response.uid,
                isAdmin: $scope.user.isAdmin,
                permissions: $scope.user.hasOwnProperty('permissions') ? $scope.user.permissions : $scope.user.permissions = {}
            };

            FirebaseFactory.saveUser(user);

            $uibModalInstance.close();
            secondaryApp.auth().signOut();
            secondaryApp.delete();

            $timeout(() => {
                ngToast.create({
                    className: 'toast-success',
                    content: `${$scope.user.displayName} ${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
                    timeout: 4000
                });
            }, 300);

        }, (error) => {
            secondaryApp.delete();
            $timeout(() => {
                let message = null;
                if (error.code === "auth/invalid-email") {
                    message = $scope.T.INVALID_EMAIL;
                } else if (error.code === "auth/weak-password") {
                    message = $scope.T.AUTH_WEAK_PASSWORD;
                } else if (error.code === "auth/email-already-in-use") {
                    message = $scope.T.AUTH_EMAIL_ALREADY_IN_USE;
                } else {
                    message =  $scope.T.INTERNAL_ERROR;
                }
                ngToast.create({
                    className: 'toast-warning',
                    content: message,
                    timeout: 4000
                });

                // $rootScope.raven.captureException(error);
                // $rootScope.raven.showReportDialog();
            }, 300);
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/views/app.sidenav/AppNewUserCtrl.js